import React from 'react';
import '../../App.css';

export default function UneteaHwasa() {
  return <h1 className='unete-a-hwasa'>UNETE A HWASA</h1>;
}


